export enum JobType {
    Unspecified = 0,
    CoiledTubing = 1,
    Snubbing = 2,
    ChemMixing = 3,
    FluidPump = 4,
    NitrogenPump = 5,
    Other = 6,
    BopFacilityTest = 7,
}